/*
 * @Description:crm客户管理菜单配置
 * @Author: 琢磨先生
 * @Date: 2024-07-15 12:26:43
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2024-08-18 09:27:15
 */
export default {
	path: '/',
	icon: '',
	meta: {
		title: '客户管理'
	},
	children: [
		{
			path: '/',
			icon: '',
			meta: {
				title: '资源管理'
			},
			children: [
				{
					path: '/crm/resource/outboundUser',
					name:'CrmOutboundUserIndex',
					icon: '',
					component: () => import('@/views/crm/resource/outboundUser'),
					meta: {
						title: '外呼用户管理'
					},
					power: 'admin/v1/kq/plan'
				},
				{
					path: '/crm/lead/pool',
					name:'CrmLeadPoolIndex',
					icon: '',
					component: () => import('@/views/crm/lead/pool'),
					meta: {
						title: '公海'
					},
					power: 'admin/v1/kq/plan'
				},
				{
					path: '/crm/resource/outboundBlacklist',
					name:'CrmOutboundBlacklistIndex',
					icon: '',
					component: () => import('@/views/crm/resource/outboundBlacklist'),
					power: 'admin/v1/kq/plan',
					meta: {
						title: '外呼黑名单'
					}
				},
				{
					path: '/crm/resource/distribution',
					name:'CrmDistributionIndex',
					icon: '',
					component: () => import('@/views/crm/resource/distribution'),
					power: 'admin/v1/kq/plan',
					meta: {
						title: '全国资源分配'
					}
				}
			]
		},
		{
			path: '/',
			icon: '',
			meta: {
				title: '线索管理'
			},
			children: [
				{
					path: '/crm/lead',
					name:'leadList',
					icon: '',
					component: () => import('@/views/crm/leadList'),
					meta: {
						title: '线索列表'
					},
					power: 'admin/v1/kq/plan'
				},
				{
					path: '/crm/lead/recycle',
					name:'CrmRecycleIndex',
					icon: '',
					component: () => import('@/views/crm/leadList/recycle'),
					power: 'admin/v1/kq/plan',
					meta: {
						title: '回收站'
					}
				},
				// {
				// 	path: '/crm/resource/leadBelong',
				// 	icon: '',
				// 	component: () => import('@/views/crm/resource/leadBelong'),
				// 	power: 'admin/v1/kq/plan',
				// 	meta: {
				// 		title: '线索所属申请'
				// 	}
				// },
				{
					path: '/crm/resource/visitday',
					name:'CrmVisitdayIndex',
					icon: '',
					component: () => import('@/views/crm/resource/visitday'),
					power: 'admin/v1/kq/plan',
					meta: {
						title: '回访超时列表'
					}
				}
			]
		}

		// {
		// 	path: '/',
		// 	icon: '',
		// 	meta: {
		// 		title: '意向学员'
		// 	},
		// 	children: [
		// 		{
		// 			path: '/crm/student',
		// 			icon: '',
		// 			component: () => import('@/views/crm/student'),
		// 			power: 'admin/v1/kq/plan',
		// 			meta: {
		// 				title: '意向学员'
		// 			}
		// 		},
		// 		{
		// 			path: '/crm/student/pool',
		// 			icon: '',
		// 			component: () => import('@/views/crm/student/pool'),
		// 			power: 'admin/v1/kq/plan',
		// 			meta: {
		// 				title: '资源池'
		// 			}
		// 		},
		// 		{
		// 			path: '/crm/student/recycle',
		// 			icon: '',
		// 			component: () => import('@/views/crm/student/recycle'),
		// 			power: 'admin/v1/kq/plan',
		// 			meta: {
		// 				title: '回收站'
		// 			}
		// 		}
		// 	]
		// },
		// {
		// 	path: '/',
		// 	icon: '',
		// 	meta: {
		// 		title: '活动管理'
		// 	},
		// 	children: [
		// 		{
		// 			path: '/crm/activity',
		// 			icon: '',
		// 			component: () => import('@/views/crm/activity/list'),
		// 			power: 'admin/v1/kq/plan',
		// 			meta: {
		// 				title: '活动列表'
		// 			}
		// 		},
		// 		{
		// 			path: '/crm/activity/channel',
		// 			icon: '',
		// 			component: () => import('@/views/crm/activity/channel'),
		// 			power: 'admin/v1/kq/plan',
		// 			meta: {
		// 				title: '活动渠道'
		// 			}
		// 		}
		// 	]
		// },
		// {
		// 	path: '/',
		// 	icon: '',
		// 	meta: {
		// 		title: '加油包'
		// 	},
		// 	children: [
		// 		{
		// 			path: '/crm/refuel/document',
		// 			icon: '',
		// 			component: () => import('@/views/crm/refuel/document'),
		// 			power: 'admin/v1/kq/plan',
		// 			meta: {
		// 				title: '资料管理'
		// 			}
		// 		}
		// 	]
		// },
		// {
		// 	path: '/',
		// 	icon: '',
		// 	meta: {
		// 		title: '管理配置'
		// 	},
		// 	children: [
		// 		{
		// 			path: '/crm/method',
		// 			icon: '',
		// 			component: () => import('@/views/crm/method'),
		// 			power: 'admin/v1/kq/plan',
		// 			meta: {
		// 				title: '跟进方式'
		// 			}
		// 		},
		// 		{
		// 			path: '/crm/tag',
		// 			icon: '',
		// 			component: () => import('@/views/crm/tag'),
		// 			power: 'admin/v1/kq/plan',
		// 			meta: {
		// 				title: '标签管理'
		// 			}
		// 		},
		// 		{
		// 			path: '/crm/source',
		// 			icon: '',
		// 			component: () => import('@/views/crm/source'),
		// 			power: 'admin/v1/kq/plan',
		// 			meta: {
		// 				title: '来源管理'
		// 			}
		// 		}
		// 	]
		// }
	]
}
